<template>
  <FormLayout title="HR-DOS | Process Leave Application">
    <div
      class="container"
      style="
        margin-top: 30px;
        margin-bottom: 50px;
        width: 95%;
        max-width: 1100px;
      "
    >
      <div class="valign-wrapper" style="margin-bottom: 10px">
        <i
          class="material-icons medium indigo-text text-darken-3"
          style="margin-right: 15px"
          >edit_document</i
        >
        <h4 class="grey-text text-darken-3 bold" style="margin: 0">
          Process Leave Application
        </h4>
      </div>

      <div class="row valign-wrapper" style="margin-bottom: 30px">
        <div class="col s8">
          <p
            class="grey-text text-darken-1"
            style="font-size: 1.1rem; margin: 0"
          >
            Please complete <b>Section 7</b> below. Sections 1-6 are locked for
            review.
          </p>
        </div>
        <div class="col s4 right-align">
          <button
            class="btn-flat grey-text text-darken-2"
            @click="$router.push('/leave-management')"
          >
            <i class="material-icons left">arrow_back</i> Back to List
          </button>
        </div>
      </div>

      <!-- FORM WRAPPER (Pointer events disabled during loading) -->
      <div class="form-wrapper" :style="loading ? 'pointer-events: none;' : ''">
        
        <!-- ========================================================================================= -->
        <!-- DESKTOP / LARGE SCREEN FORM (Strict Paper Replica) -->
        <!-- ========================================================================================= -->
        <div class="hide-on-med-and-down">
          <div
            class="paper-form z-depth-2 white"
            style="margin: 0 auto; position: relative"
          >
            <!-- MINIMALIST OVERLAY LOADER -->
            <div v-if="loading" class="loader-overlay">
              <div class="minimal-loader">
                <span class="loader-text">Loading Application Data</span>
                <div class="loader-line"></div>
              </div>
            </div>

            <div class="form-header flex-row" style="align-items: flex-start">
              <div class="header-left">
                <p style="text-align: left; font-style: italic; margin: 0">
                  Civil Service Form No. 6<br />Revised 2020
                </p>
              </div>
              <div
                style="
                  margin-top: 45px;
                  margin-left: -90px;
                  display: flex;
                  gap: 10px;
                "
              >
                <img
                  src="@/assets/bagong-pilipinas-logo.png"
                  alt="Bagong Pilipinas"
                  class="header-logo"
                  @error="$event.target.style.display = 'none'"
                />
                <img
                  src="@/assets/LTOlogo.png"
                  alt="LTO"
                  class="header-logo"
                  @error="$event.target.style.display = 'none'"
                />
              </div>
              <div class="header-center">
                <p class="republic-text">
                  Republic of the Philippines<br />
                  Department of Transportation<br />
                  <b>LAND TRANSPORTATION OFFICE</b><br />
                  Regional Office No. 02<br />
                  Tuguegarao City, Cagayan
                </p>
                <h5 class="form-title" style="margin-left: -165px">
                  <b>APPLICATION FOR LEAVE</b>
                </h5>
              </div>
              <div class="header-right right-align">
                <p style="margin: 0 60px 10px 0; font-size: 1rem">
                  <b>ANNEX A</b>
                </p>
                <div class="stamp-box">Stamp of Date of Receipt</div>
              </div>
            </div>

            <div class="form-inputs">
              <div class="row1and2 read-only-mode">
                <div class="form-row flex-row" style="padding-top: 2px">
                  <div
                    class="form-col w-30 padding-sm"
                    style="margin-right: 50px"
                  >
                    <label class="cs-label">1. OFFICE/DEPARTMENT</label>
                    <input
                      type="text"
                      class="cs-input"
                      v-model="form.office"
                      readonly
                    />
                  </div>
                  <div class="form-col w-70 padding-sm" style="display: flex">
                    <label style="margin-right: 60px" class="cs-label"
                      >2. NAME:</label
                    >
                    <div class="name-grid">
                      <div>
                        <div class="sub-label center-align">(Last)</div>
                        <input
                          type="text"
                          class="cs-input center-align"
                          v-model="form.lastName"
                          readonly
                        />
                      </div>
                      <div>
                        <div class="sub-label center-align">(First)</div>
                        <input
                          type="text"
                          class="cs-input center-align"
                          v-model="form.firstName"
                          readonly
                        />
                      </div>
                      <div>
                        <div class="sub-label center-align">(Middle)</div>
                        <input
                          type="text"
                          class="cs-input center-align"
                          v-model="form.middleName"
                          readonly
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-row border-top flex-row">
                  <div
                    class="form-col w-35 padding-sm"
                    style="display: flex; margin-right: 60px"
                  >
                    <label
                      class="cs-label for-row2"
                      style="margin-right: 70px; margin-top: 8px"
                      >3. DATE OF FILING</label
                    >
                    <input
                      type="text"
                      class="cs-input"
                      :value="formatDate(form.dateOfFiling)"
                      readonly
                    />
                  </div>
                  <div
                    class="form-col w-45 padding-sm"
                    style="display: flex; margin-right: 40px"
                  >
                    <label
                      class="cs-label for-row2"
                      style="margin-right: 5px; margin-top: 8px"
                      >4. POSITION</label
                    >
                    <input
                      type="text"
                      class="cs-input"
                      v-model="form.position"
                      readonly
                    />
                  </div>
                  <div class="form-col w-20 padding-sm" style="display: flex">
                    <label
                      class="cs-label for-row2"
                      style="margin-right: 5px; margin-top: 8px"
                      >5. SALARY</label
                    >
                    <input
                      type="text"
                      class="cs-input"
                      v-model="form.salary"
                      readonly
                    />
                  </div>
                </div>
              </div>

              <div class="form-row section-header center-align row3">
                <b>6. DETAILS OF APPLICATION</b>
              </div>

              <div class="form-row flex-row row4 read-only-mode">
                <div class="form-col w-55 border-right padding-md">
                  <label class="cs-label" style="margin-bottom: 10px"
                    >6.A TYPE OF LEAVE TO BE AVAILED OF</label
                  >
                  <div class="cs-custom-radios">
                    <label class="cs-radio-row"
                      ><input
                        type="radio"
                        :checked="form.leaveType === 'Vacation Leave'"
                        disabled
                      />
                      <div class="cs-box"></div>
                      <div class="cs-text">
                        <strong>Vacation Leave</strong>
                      </div></label
                    >
                    <label class="cs-radio-row"
                      ><input
                        type="radio"
                        :checked="form.leaveType === 'Mandatory/Forced Leave'"
                        disabled
                      />
                      <div class="cs-box"></div>
                      <div class="cs-text">
                        <strong>Mandatory/Forced Leave</strong>
                      </div></label
                    >
                    <label class="cs-radio-row"
                      ><input
                        type="radio"
                        :checked="form.leaveType === 'Sick Leave'"
                        disabled
                      />
                      <div class="cs-box"></div>
                      <div class="cs-text">
                        <strong>Sick Leave</strong>
                      </div></label
                    >
                    <label class="cs-radio-row"
                      ><input
                        type="radio"
                        :checked="form.leaveType === 'Maternity Leave'"
                        disabled
                      />
                      <div class="cs-box"></div>
                      <div class="cs-text">
                        <strong>Maternity Leave</strong>
                      </div></label
                    >
                    <label class="cs-radio-row"
                      ><input
                        type="radio"
                        :checked="form.leaveType === 'Paternity Leave'"
                        disabled
                      />
                      <div class="cs-box"></div>
                      <div class="cs-text">
                        <strong>Paternity Leave</strong>
                      </div></label
                    >
                    <label class="cs-radio-row"
                      ><input
                        type="radio"
                        :checked="form.leaveType === 'Special Privilege Leave'"
                        disabled
                      />
                      <div class="cs-box"></div>
                      <div class="cs-text">
                        <strong>Special Privilege Leave</strong>
                      </div></label
                    >
                    <label class="cs-radio-row"
                      ><input
                        type="radio"
                        :checked="form.leaveType === 'Solo Parent Leave'"
                        disabled
                      />
                      <div class="cs-box"></div>
                      <div class="cs-text">
                        <strong>Solo Parent Leave</strong>
                      </div></label
                    >
                    <label class="cs-radio-row"
                      ><input
                        type="radio"
                        :checked="form.leaveType === 'Study Leave'"
                        disabled
                      />
                      <div class="cs-box"></div>
                      <div class="cs-text">
                        <strong>Study Leave</strong>
                      </div></label
                    >
                    <label class="cs-radio-row"
                      ><input
                        type="radio"
                        :checked="form.leaveType === '10-Day VAWC Leave'"
                        disabled
                      />
                      <div class="cs-box"></div>
                      <div class="cs-text">
                        <strong>10-Day VAWC Leave</strong>
                      </div></label
                    >
                    <label class="cs-radio-row"
                      ><input
                        type="radio"
                        :checked="form.leaveType === 'Rehabilitation Privilege'"
                        disabled
                      />
                      <div class="cs-box"></div>
                      <div class="cs-text">
                        <strong>Rehabilitation Privilege</strong>
                      </div></label
                    >
                    <label class="cs-radio-row"
                      ><input
                        type="radio"
                        :checked="
                          form.leaveType === 'Special Leave Benefits for Women'
                        "
                        disabled
                      />
                      <div class="cs-box"></div>
                      <div class="cs-text">
                        <strong>Special Leave Benefits for Women</strong>
                      </div></label
                    >
                    <label class="cs-radio-row"
                      ><input
                        type="radio"
                        :checked="form.leaveType === 'Special Emergency Leave'"
                        disabled
                      />
                      <div class="cs-box"></div>
                      <div class="cs-text">
                        <strong>Special Emergency (Calamity) Leave</strong>
                      </div></label
                    >
                    <label class="cs-radio-row"
                      ><input
                        type="radio"
                        :checked="form.leaveType === 'Adoption Leave'"
                        disabled
                      />
                      <div class="cs-box"></div>
                      <div class="cs-text">
                        <strong>Adoption Leave</strong>
                      </div></label
                    >
                    <label
                      class="cs-radio-row others-row"
                      style="margin-bottom: 20px !important"
                    >
                      <input
                        type="radio"
                        :checked="form.leaveType === 'Others'"
                        disabled
                      />
                      <div class="cs-box"></div>
                      <div class="cs-text others-text-wrapper">
                        <i>Others:</i>
                        <input
                          type="text"
                          class="cs-input inline-line thick-line"
                          v-model="form.leaveTypeOthers"
                          readonly
                          style="flex: 1; margin: 0 10px !important"
                        />
                      </div>
                    </label>
                  </div>
                </div>

                <div class="form-col w-45 padding-md">
                  <label class="cs-label" style="margin-bottom: 10px"
                    >6.B DETAILS OF LEAVE</label
                  >

                  <div class="sub-section">
                    <p
                      style="
                        text-align: left;
                        font-style: italic;
                        margin: 3px 0 3px 18px;
                      "
                    >
                      In case of Vacation/Special Privilege Leave:
                    </p>
                    <div class="cs-custom-radios">
                      <label class="cs-radio-row">
                        <input
                          type="radio"
                          :checked="
                            form.leaveDetails === 'Within the Philippines'
                          "
                          disabled
                        />
                        <div class="cs-box"></div>
                        <div class="cs-text others-text-wrapper">
                          <span><strong>Within the Philippines</strong></span>
                          <input
                            type="text"
                            class="cs-input inline-line thick-line"
                            :value="
                              form.leaveDetails === 'Within the Philippines'
                                ? form.leaveDetailsSpecify
                                : ''
                            "
                            readonly
                            style="flex: 1; margin-left: 10px !important"
                          />
                        </div>
                      </label>
                      <label class="cs-radio-row others-row">
                        <input
                          type="radio"
                          :checked="form.leaveDetails === 'Abroad'"
                          disabled
                        />
                        <div class="cs-box"></div>
                        <div class="cs-text others-text-wrapper">
                          <span><strong>Abroad (Specify)</strong></span>
                          <input
                            type="text"
                            class="cs-input inline-line thick-line"
                            :value="
                              form.leaveDetails === 'Abroad'
                                ? form.leaveDetailsSpecify
                                : ''
                            "
                            readonly
                            style="flex: 1; margin-left: 10px !important"
                          />
                        </div>
                      </label>
                    </div>
                  </div>

                  <div class="sub-section">
                    <p
                      style="
                        text-align: left;
                        font-style: italic;
                        margin: 3px 0 3px 18px;
                      "
                    >
                      In case of Sick Leave:
                    </p>
                    <div class="cs-custom-radios">
                      <label class="cs-radio-row others-row">
                        <input
                          type="radio"
                          :checked="form.leaveDetails === 'In Hospital'"
                          disabled
                        />
                        <div class="cs-box"></div>
                        <div class="cs-text others-text-wrapper">
                          <span
                            ><strong>In Hospital (Specify Illness)</strong></span
                          >
                          <input
                            type="text"
                            class="cs-input inline-line thick-line"
                            v-model="form.sickSpecifyHospital"
                            readonly
                            style="flex: 1; margin-left: 10px !important"
                          />
                        </div>
                      </label>
                      <label class="cs-radio-row others-row">
                        <input
                          type="radio"
                          :checked="form.leaveDetails === 'Out Patient'"
                          disabled
                        />
                        <div class="cs-box"></div>
                        <div class="cs-text others-text-wrapper">
                          <span
                            >O<strong>ut Patient (Specify Illness)</strong></span
                          >
                          <input
                            type="text"
                            class="cs-input inline-line thick-line"
                            v-model="form.sickSpecifyOutPatient"
                            readonly
                            style="flex: 1; margin-left: 10px !important"
                          />
                        </div>
                      </label>
                    </div>
                  </div>

                  <div class="sub-section">
                    <p
                      style="
                        text-align: left;
                        font-style: italic;
                        margin: 3px 0 3px 18px;
                      "
                    >
                      In case of Special Leave Benefits for Women:
                    </p>
                    <div
                      class="flex-row valign-wrapper"
                      style="margin-left: 10px"
                    >
                      <p style="text-align: left; margin: 3px 0 3px 18px">
                        (Specify Illness):
                      </p>
                      <input
                        :disabled="
                          form.leaveType !== 'Special Leave Benefits for Women' ||
                          currentStep === 2
                        "
                        type="text"
                        class="cs-input inline-line thick-line"
                        v-model="form.womenSpecify"
                        :readonly="currentStep === 2"
                        style="
                          flex: 1;
                          margin: 0 10px !important;
                          margin-right: 10px !important;
                        "
                      />
                    </div>
                  </div>

                  <div class="sub-section">
                    <p
                      style="
                        text-align: left;
                        font-style: italic;
                        margin: 3px 0 3px 18px;
                      "
                    >
                      In case of Study Leave:
                    </p>
                    <div class="cs-custom-radios">
                      <label class="cs-radio-row">
                        <input
                          type="radio"
                          :checked="
                            form.leaveDetails === 'Completion of Master\'s Degree'
                          "
                          disabled
                        />
                        <div class="cs-box"></div>
                        <div class="cs-text">
                          <strong>Completion of Master's Degree</strong>
                        </div>
                      </label>
                      <label class="cs-radio-row">
                        <input
                          type="radio"
                          :checked="
                            form.leaveDetails === 'BAR/Board Examination Review'
                          "
                          disabled
                        />
                        <div class="cs-box"></div>
                        <div class="cs-text">
                          <strong>BAR/Board Examination Review</strong>
                        </div>
                      </label>
                    </div>
                  </div>

                  <div class="sub-section">
                    <div
                      class="flex-row valign-wrapper"
                      style="margin-left: 10px"
                    >
                      <p
                        style="
                          text-align: left;
                          font-style: italic;
                          margin: 3px 0 3px 18px;
                        "
                      >
                        Other purpose:
                      </p>
                      <input
                        type="text"
                        class="cs-input inline-line thick-line"
                        :value="getCustomLeaveDetails(form.leaveDetails)"
                        readonly
                        style="
                          flex: 1;
                          margin-left: 10px !important;
                          margin-right: 10px !important;
                        "
                      />
                    </div>
                    <div class="cs-custom-radios">
                      <label class="cs-radio-row">
                        <input
                          type="radio"
                          :checked="form.leaveDetails === 'Monetization'"
                          disabled
                        />
                        <div class="cs-box"></div>
                        <div class="cs-text">Monetization of Leave Credits</div>
                      </label>
                      <label class="cs-radio-row">
                        <input
                          type="radio"
                          :checked="form.leaveDetails === 'Terminal'"
                          disabled
                        />
                        <div class="cs-box"></div>
                        <div class="cs-text">Terminal Leave</div>
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-row flex-row row5 read-only-mode">
                <div class="form-col w-55 border-right padding-md">
                  <label class="cs-label"
                    >6.C NUMBER OF WORKING DAYS APPLIED FOR</label
                  >
                  <input
                    style="width: 85%; padding-left: 10px !important"
                    type="text"
                    class="cs-input inline-line"
                    v-model="form.workingDays"
                    readonly
                  />
                  <label
                    class="cs-label"
                    style="margin-top: 15px; margin-left: 29px"
                    >INCLUSIVE DATES</label
                  >
                  <input
                    style="width: 85%; padding-left: 10px !important"
                    type="text"
                    class="cs-input inline-line"
                    v-model="form.inclusiveDates"
                    readonly
                  />
                </div>
                <div class="form-col w-45 padding-md">
                  <label class="cs-label" style="margin-bottom: 10px"
                    >6.D COMMUTATION</label
                  >
                  <div class="cs-custom-radios">
                    <label class="cs-radio-row">
                      <input
                        type="radio"
                        :checked="form.commutation === 'Not Requested'"
                        disabled
                      />
                      <div class="cs-box"></div>
                      <div class="cs-text">Not Requested</div>
                    </label>
                    <label class="cs-radio-row">
                      <input
                        type="radio"
                        :checked="form.commutation === 'Requested'"
                        disabled
                      />
                      <div class="cs-box"></div>
                      <div class="cs-text">Requested</div>
                    </label>
                  </div>
                  <div
                    class="signature-box center-align"
                    style="margin-top: 30px; margin-bottom: 10px"
                  >
                    <div style="width: 80%" class="signature-line"></div>
                    <div class="sub-label">(Signature of Applicant)</div>
                  </div>
                </div>
              </div>

              <div class="form-row section-header center-align row6">
                <b>7. DETAILS OF ACTION ON APPLICATION</b>
              </div>

              <div class="form-row flex-row row7">
                <div
                  class="form-col w-55 border-right padding-md"
                  :class="
                    position_id === 8 ? 'editable-section' : 'read-only-mode'
                  "
                >
                  <label
                    class="cs-label"
                    style="margin-bottom: 5px"
                    :class="{ 'error-text': errors.actionAsOf || errors.section7Table }"
                    >7.A CERTIFICATION OF LEAVE CREDITS</label
                  >

                  <div class="flex-row center-content">
                    <span
                      style="
                        font-size: 0.85rem;
                        margin-right: 10px;
                        margin-left: 127px;
                      "
                      >As of</span
                    >
                    <input
                      ref="actionAsOf"
                      type="date"
                      class="cs-input inline-line thick-line"
                      v-model="form.actionAsOf"
                      :readonly="position_id !== 8"
                      style="
                        width: 329px;
                        text-align: center;
                        margin-bottom: 0 !important;
                      "
                    />
                  </div>

                  <table class="cert-table">
                    <thead>
                      <tr>
                        <th width="40%"></th>
                        <th>Vacation Leave</th>
                        <th>Sick Leave</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Total Earned</td>
                        <td>
                          <input
                            type="text"
                            class="table-input"
                            :class="{ 'border-red': errors.section7Table && (!form.vacationEarned && form.vacationEarned !== 0) }"
                            v-model="form.vacationEarned"
                            @input="sanitizeDecimal('vacationEarned'); errors.section7Table = false"
                            :readonly="position_id !== 8"
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            class="table-input"
                            :class="{ 'border-red': errors.section7Table && (!form.sickEarned && form.sickEarned !== 0) }"
                            v-model="form.sickEarned"
                            @input="sanitizeDecimal('sickEarned'); errors.section7Table = false"
                            :readonly="position_id !== 8"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Less this application</td>
                        <td>
                          <input
                            type="text"
                            class="table-input"
                            :class="{ 'border-red': errors.section7Table && (!form.vacationLess && form.vacationLess !== 0) }"
                            v-model="form.vacationLess"
                            @input="sanitizeDecimal('vacationLess'); errors.section7Table = false"
                            :readonly="position_id !== 8"
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            class="table-input"
                            :class="{ 'border-red': errors.section7Table && (!form.sickLess && form.sickLess !== 0) }"
                            v-model="form.sickLess"
                            @input="sanitizeDecimal('sickLess'); errors.section7Table = false"
                            :readonly="position_id !== 8"
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Balance</td>
                        <td>
                          <input
                            type="text"
                            class="table-input"
                            v-model="form.vacationBalance"
                            @input="sanitizeDecimal('vacationBalance')"
                            readonly
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            class="table-input"
                            v-model="form.sickBalance"
                            @input="sanitizeDecimal('sickBalance')"
                            readonly
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>

                  <div
                    class="signature-box center-align"
                    style="margin-top: 50px; margin-bottom: 20px"
                  >
                    <div
                      v-if="signatures.hr"
                      style="height: 50px; margin-bottom: 5px"
                    >
                      <img
                        :src="signatures.hr"
                        alt="HR Signature"
                        style="max-height: 100%; object-fit: contain"
                      />
                    </div>
                    <button
                      v-if="position_id === 8"
                      type="button"
                      class="btn-small indigo darken-3"
                      @click="openSignatureModal('hr')"
                      style="
                        margin-bottom: 5px;
                        border-radius: 4px;
                        padding: 0 10px;
                      "
                    >
                      <i class="material-icons left" style="margin-right: 5px"
                        >draw</i
                      >
                      {{ signatures.hr ? "Retake" : "Sign Here" }}
                    </button>
                    <div
                      class="signature-line"
                      style="width: 80%"
                      :class="{
                        'error-text border-red':
                          errors.signature && position_id === 8,
                      }"
                    ></div>
                    <div
                      class="sub-label"
                      style="margin-bottom: 10px"
                      :class="{
                        'error-text': errors.signature && position_id === 8,
                      }"
                    >
                      Administrative Officer V (HRMO III)
                    </div>
                  </div>
                </div>

                <div
                  class="form-col w-45 padding-md"
                  :class="
                    position_id === 3 ? 'editable-section' : 'read-only-mode'
                  "
                >
                  <label
                    class="cs-label"
                    style="margin-bottom: 15px"
                    :class="{
                      'error-text':
                        errors.recommendation || errors.disapprovalReason,
                    }"
                    >7.B RECOMMENDATION</label
                  >

                  <div class="cs-custom-radios">
                    <label class="cs-radio-row" style="align-items: flex-start">
                      <input
                        ref="recommendation"
                        type="radio"
                        value="For approval"
                        v-model="form.recommendation"
                        :disabled="position_id !== 3"
                      />
                      <div
                        class="cs-box"
                        style="height: 29px; margin-bottom: 0"
                      ></div>
                      <div
                        class="cs-text"
                        style="
                          padding: 0 0 5px 0;
                          line-height: 24px;
                          margin-top: 8px !important;
                        "
                      >
                        For approval
                      </div>
                    </label>

                    <label class="cs-radio-row" style="align-items: flex-start">
                      <input
                        type="radio"
                        value="For disapproval"
                        v-model="form.recommendation"
                        :disabled="position_id !== 3"
                      />
                      <div
                        class="cs-box"
                        style="
                          height: 35px;
                          border-bottom: 3px solid #000;
                          margin-top: -8px !important;
                        "
                      ></div>
                      <div class="cs-text" style="width: 100%; padding: 0">
                        <div
                          style="
                            display: flex;
                            align-items: flex-end;
                            margin-bottom: 5px;
                          "
                        >
                          <p
                            style="
                              white-space: nowrap;
                              margin-right: 5px !important;
                              margin-top: 5px !important;
                              margin-bottom: 8px !important;
                              line-height: 1.2;
                            "
                          >
                            For disapproval due to
                          </p>
                          <input
                            ref="reason1"
                            type="text"
                            class="cs-input"
                            v-model="form.disapprovalReason1"
                            :disabled="form.recommendation !== 'For disapproval' || position_id !== 3"
                            style="
                              flex: 1;
                              border-bottom: 2px solid #000 !important;
                              height: 1.5rem !important;
                              text-align: left !important;
                            "
                            maxlength="29"
                            @input="
                              handleAutoTab(
                                form.disapprovalReason1,
                                29,
                                'reason2',
                              )
                            "
                          />
                        </div>

                        <input
                          ref="reason2"
                          type="text"
                          class="cs-input"
                          v-model="form.disapprovalReason2"
                          :disabled="
                            form.recommendation !== 'For disapproval' ||
                            !form.disapprovalReason1 ||
                            position_id !== 3
                          "
                          style="
                            width: 100%;
                            border-bottom: 2px solid #000 !important;
                            height: 1.5rem !important;
                            text-align: left !important;
                            margin-bottom: 5px !important;
                          "
                          maxlength="51"
                          @input="
                            handleAutoTab(form.disapprovalReason2, 51, 'reason3')
                          "
                          @keydown="
                            handleBackspace(
                              $event,
                              form.disapprovalReason2,
                              'reason1',
                            )
                          "
                        />
                        <input
                          ref="reason3"
                          type="text"
                          class="cs-input"
                          v-model="form.disapprovalReason3"
                          :disabled="
                            form.recommendation !== 'For disapproval' ||
                            !form.disapprovalReason2 ||
                            position_id !== 3
                          "
                          style="
                            width: 100%;
                            border-bottom: 2px solid #000 !important;
                            height: 1.5rem !important;
                            text-align: left !important;
                          "
                          maxlength="51"
                          @keydown="
                            handleBackspace(
                              $event,
                              form.disapprovalReason3,
                              'reason2',
                            )
                          "
                        />
                      </div>
                    </label>
                  </div>

                  <div
                    class="signature-box center-align"
                    style="margin-top: 47px"
                  >
                    <div
                      v-if="signatures.supervisor"
                      style="height: 50px; margin-bottom: 5px"
                    >
                      <img
                        :src="signatures.supervisor"
                        alt="Supervisor Signature"
                        style="max-height: 100%; object-fit: contain"
                      />
                    </div>
                    <button
                      v-if="position_id === 3"
                      type="button"
                      class="btn-small indigo darken-3"
                      @click="openSignatureModal('supervisor')"
                      style="
                        margin-bottom: 5px;
                        border-radius: 4px;
                        padding: 0 10px;
                      "
                    >
                      <i class="material-icons left" style="margin-right: 5px"
                        >draw</i
                      >
                      {{ signatures.supervisor ? "Retake" : "Sign Here" }}
                    </button>
                    <div
                      class="signature-line"
                      style="width: 80%"
                      :class="{
                        'error-text border-red':
                          errors.signature && position_id === 3,
                      }"
                    ></div>
                    <div
                      class="sub-label"
                      style="margin-bottom: 10px"
                      :class="{
                        'error-text': errors.signature && position_id === 3,
                      }"
                    >
                      {{
                        form.position === "CHIEF ADMINISTRATIVE OFFICER"
                          ? "Assistant Regional Director"
                          : "Immediate Supervisor"
                      }}
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="form-row flex-row row8"
                :class="position_id === 1 ? 'editable-section' : 'read-only-mode'"
              >
                <div class="form-col w-55 padding-md border-right">
                  <label
                    class="cs-label"
                    style="margin-bottom: 10px"
                    :class="{ 'error-text': errors.approvalDays }"
                    >7.C APPROVED FOR:</label
                  >

                  <div class="flex-row valign-wrapper" style="margin-bottom: 5px">
                    <input
                      ref="approvedDaysWithPay"
                      type="text"
                      class="cs-input inline-line thick-line"
                      v-model="form.approvedDaysWithPay"
                      style="width: 60px; text-align: center"
                      @input="sanitizeDecimal('approvedDaysWithPay')"
                      :readonly="position_id !== 1"
                    />
                    <span
                      style="font-size: 0.85rem; color: #000; margin-left: 10px"
                      >days with pay</span
                    >
                  </div>
                  <div class="flex-row valign-wrapper" style="margin-bottom: 5px">
                    <input
                      type="text"
                      class="cs-input inline-line thick-line"
                      v-model="form.approvedDaysWithoutPay"
                      style="width: 60px; text-align: center"
                      @input="sanitizeDecimal('approvedDaysWithoutPay')"
                      :readonly="position_id !== 1"
                    />
                    <span
                      style="font-size: 0.85rem; color: #000; margin-left: 10px"
                      >days without pay</span
                    >
                  </div>
                  <div class="flex-row valign-wrapper">
                    <input
                      type="text"
                      class="cs-input inline-line thick-line"
                      v-model="form.approvedOthers"
                      style="width: 60px; text-align: center"
                      :readonly="position_id !== 1"
                    />
                    <span
                      style="font-size: 0.85rem; color: #000; margin-left: 10px"
                      >others (Specify)</span
                    >
                  </div>
                </div>

                <div class="form-col w-45 padding-md">
                  <div style="display: flex; align-items: flex-end">
                    <label class="cs-label" style="margin-bottom: 10px"
                      >7.D DISAPPROVED DUE TO:
                    </label>
                    <input
                      ref="finalReason1"
                      type="text"
                      class="cs-input"
                      v-model="form.finalDisapprovalReason1"
                      :readonly="position_id !== 1"
                      style="
                        width: 100%;
                        border-bottom: 2px solid #000 !important;
                        height: 1.5rem !important;
                        margin-left: 50px !important;
                        text-align: left !important;
                      "
                      maxlength="30"
                      @input="
                        handleAutoTab(
                          form.finalDisapprovalReason1,
                          29,
                          'finalReason2',
                        )
                      "
                    />
                  </div>
                  <input
                    ref="finalReason2"
                    type="text"
                    class="cs-input"
                    v-model="form.finalDisapprovalReason2"
                    :disabled="!form.finalDisapprovalReason1"
                    :readonly="position_id !== 1"
                    style="
                      width: 100%;
                      border-bottom: 2px solid #000 !important;
                      height: 1.5rem !important;
                      margin-bottom: 4px !important;
                      text-align: left !important;
                    "
                    maxlength="57"
                    @input="
                      handleAutoTab(
                        form.finalDisapprovalReason2,
                        57,
                        'finalReason3',
                      )
                    "
                    @keydown="
                      handleBackspace(
                        $event,
                        form.finalDisapprovalReason2,
                        'finalReason1',
                      )
                    "
                  />
                  <input
                    ref="finalReason3"
                    type="text"
                    class="cs-input"
                    v-model="form.finalDisapprovalReason3"
                    :disabled="!form.finalDisapprovalReason2"
                    :readonly="position_id !== 1"
                    style="
                      width: 100%;
                      border-bottom: 2px solid #000 !important;
                      height: 1.5rem !important;
                      margin-bottom: 4px !important;
                      text-align: left !important;
                    "
                    maxlength="57"
                    @input="
                      handleAutoTab(
                        form.finalDisapprovalReason3,
                        57,
                        'finalReason4',
                      )
                    "
                    @keydown="
                      handleBackspace(
                        $event,
                        form.finalDisapprovalReason3,
                        'finalReason2',
                      )
                    "
                  />
                  <input
                    ref="finalReason4"
                    type="text"
                    class="cs-input"
                    v-model="form.finalDisapprovalReason4"
                    :disabled="!form.finalDisapprovalReason3"
                    :readonly="position_id !== 1"
                    style="
                      width: 100%;
                      border-bottom: 2px solid #000 !important;
                      height: 1.5rem !important;
                      text-align: left !important;
                    "
                    maxlength="57"
                    @keydown="
                      handleBackspace(
                        $event,
                        form.finalDisapprovalReason4,
                        'finalReason3',
                      )
                    "
                  />
                </div>
              </div>

              <div
                class="form-row row9 center-align padding-md"
                :class="position_id === 1 ? 'editable-section' : 'read-only-mode'"
              >
                <div
                  class="signature-box center-align"
                  style="margin-top: 25px; margin-bottom: 20px"
                >
                  <div
                    v-if="signatures.head"
                    style="height: 50px; margin-bottom: 5px"
                  >
                    <img
                      :src="signatures.head"
                      alt="Approver Signature"
                      style="max-height: 100%; object-fit: contain"
                    />
                  </div>
                  <button
                    v-if="position_id === 1"
                    type="button"
                    class="btn-small indigo darken-3"
                    @click="openSignatureModal('head')"
                    style="
                      margin-bottom: 5px;
                      border-radius: 4px;
                      padding: 0 10px;
                    "
                  >
                    <i class="material-icons left" style="margin-right: 5px"
                      >draw</i
                    >
                    {{ signatures.head ? "Retake" : "Sign Here" }}
                  </button>
                  <div
                    class="signature-line"
                    style="width: 60%; margin: 0 auto"
                    :class="{
                      'error-text border-red':
                        errors.signature && position_id === 1,
                    }"
                  ></div>
                  <div
                    class="sub-label"
                    :class="{
                      'error-text': errors.signature && position_id === 1,
                    }"
                  >
                    (Authorized Official Signature)
                  </div>
                </div>

                <div
                  v-if="
                    rawApplicationData &&
                    rawApplicationData.supporting_document_path
                  "
                  style="margin-top: 10px"
                >
                  <a
                    :href="
                      getFileUrl(rawApplicationData.supporting_document_path)
                    "
                    target="_blank"
                    class="btn-small indigo darken-3 waves-effect waves-light"
                    style="border-radius: 4px"
                  >
                    <i class="material-icons left">attach_file</i> View Attached
                    Medical Cert / Document
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ========================================================================================= -->
        <!-- MOBILE / SMALL SCREEN FORM (Clean Stacked Layout) -->
        <!-- ========================================================================================= -->
        <div class="hide-on-large-only">
          <div class="mobile-paper-form z-depth-1 white">
            
            <!-- MINIMALIST OVERLAY LOADER -->
            <div v-if="loading" class="loader-overlay" style="border-radius: 8px;">
              <div class="minimal-loader">
                <span class="loader-text">Loading...</span>
                <div class="loader-line"></div>
              </div>
            </div>

            <div class="center-align" style="margin-bottom: 25px;">
              <img src="@/assets/LTOlogo.png" style="height: 60px; margin-bottom: 10px;">
              <h6 style="font-weight: bold; margin: 0; color: #1565c0;">APPLICATION FOR LEAVE</h6>
              <p style="font-size: 0.8rem; color: #777; margin-top: 5px;">Civil Service Form No. 6</p>
            </div>

            <div class="mobile-section read-only-mode">
              <label class="mobile-label">1. OFFICE/DEPARTMENT</label>
              <input type="text" class="browser-default mobile-input" v-model="form.office" readonly>
            </div>

            <div class="mobile-section read-only-mode">
              <label class="mobile-label">2. NAME</label>
              <div class="mobile-name-grid">
                <div style="flex: 1;">
                  <label class="mobile-sub-label">Last Name</label>
                  <input type="text" class="browser-default mobile-input" v-model="form.lastName" readonly>
                </div>
                <div style="flex: 1;">
                  <label class="mobile-sub-label">First Name</label>
                  <input type="text" class="browser-default mobile-input" v-model="form.firstName" readonly>
                </div>
                <div style="flex: 1;">
                  <label class="mobile-sub-label">Middle Name</label>
                  <input type="text" class="browser-default mobile-input" v-model="form.middleName" readonly>
                </div>
              </div>
            </div>

            <div class="mobile-section read-only-mode">
              <label class="mobile-label">3. DATE OF FILING</label>
              <input type="text" class="browser-default mobile-input" :value="formatDate(form.dateOfFiling)" readonly>
            </div>

            <div class="mobile-section read-only-mode">
              <label class="mobile-label">4. POSITION</label>
              <input type="text" class="browser-default mobile-input" v-model="form.position" readonly>
            </div>

            <div class="mobile-section read-only-mode">
              <label class="mobile-label">5. SALARY</label>
              <input type="number" class="browser-default mobile-input" v-model="form.salary" readonly>
            </div>

            <div class="mobile-section-header center-align">6. DETAILS OF APPLICATION</div>

            <div class="mobile-section read-only-mode">
              <label class="mobile-label">6.A TYPE OF LEAVE</label>
              <div class="mobile-radio-group">
                <label>
                  <input type="radio" class="with-gap" :checked="form.leaveType === 'Vacation Leave'" disabled>
                  <span>Vacation Leave</span>
                </label>
                <label>
                  <input type="radio" class="with-gap" :checked="form.leaveType === 'Mandatory/Forced Leave'" disabled>
                  <span>Mandatory/Forced Leave</span>
                </label>
                <label>
                  <input type="radio" class="with-gap" :checked="form.leaveType === 'Sick Leave'" disabled>
                  <span>Sick Leave</span>
                </label>
                <label>
                  <input type="radio" class="with-gap" :checked="form.leaveType === 'Maternity Leave'" disabled>
                  <span>Maternity Leave</span>
                </label>
                <label>
                  <input type="radio" class="with-gap" :checked="form.leaveType === 'Paternity Leave'" disabled>
                  <span>Paternity Leave</span>
                </label>
                <label>
                  <input type="radio" class="with-gap" :checked="form.leaveType === 'Special Privilege Leave'" disabled>
                  <span>Special Privilege Leave</span>
                </label>
                <label>
                  <input type="radio" class="with-gap" :checked="form.leaveType === 'Solo Parent Leave'" disabled>
                  <span>Solo Parent Leave</span>
                </label>
                <label>
                  <input type="radio" class="with-gap" :checked="form.leaveType === 'Study Leave'" disabled>
                  <span>Study Leave</span>
                </label>
                <label>
                  <input type="radio" class="with-gap" :checked="form.leaveType === '10-Day VAWC Leave'" disabled>
                  <span>10-Day VAWC Leave</span>
                </label>
                <label>
                  <input type="radio" class="with-gap" :checked="form.leaveType === 'Rehabilitation Privilege'" disabled>
                  <span>Rehabilitation Privilege</span>
                </label>
                <label>
                  <input type="radio" class="with-gap" :checked="form.leaveType === 'Special Leave Benefits for Women'" disabled>
                  <span>Special Leave Benefits for Women</span>
                </label>
                <label>
                  <input type="radio" class="with-gap" :checked="form.leaveType === 'Special Emergency Leave'" disabled>
                  <span>Special Emergency Leave</span>
                </label>
                <label>
                  <input type="radio" class="with-gap" :checked="form.leaveType === 'Adoption Leave'" disabled>
                  <span>Adoption Leave</span>
                </label>
                <label>
                  <input type="radio" class="with-gap" :checked="form.leaveType === 'Others'" disabled>
                  <span>Others (Specify):</span>
                </label>
                <input v-if="form.leaveType === 'Others'" type="text" class="browser-default mobile-input" v-model="form.leaveTypeOthers" readonly style="margin-top: 5px;">
              </div>
            </div>

            <div class="mobile-section read-only-mode">
              <label class="mobile-label">6.B DETAILS OF LEAVE</label>
              
              <p class="mobile-hint">In case of Vacation/Special Privilege Leave:</p>
              <div class="mobile-radio-group">
                <label>
                  <input type="radio" class="with-gap" :checked="form.leaveDetails === 'Within the Philippines'" disabled>
                  <span>Within the Philippines</span>
                </label>
                <input v-if="form.leaveDetails === 'Within the Philippines'" type="text" class="browser-default mobile-input" :value="form.leaveDetailsSpecify" readonly style="margin-top: 5px;">
                
                <label>
                  <input type="radio" class="with-gap" :checked="form.leaveDetails === 'Abroad'" disabled>
                  <span>Abroad (Specify)</span>
                </label>
                <input v-if="form.leaveDetails === 'Abroad'" type="text" class="browser-default mobile-input" :value="form.leaveDetailsSpecify" readonly style="margin-top: 5px;">
              </div>

              <p class="mobile-hint" style="margin-top: 15px;">In case of Sick Leave:</p>
              <div class="mobile-radio-group">
                <label>
                  <input type="radio" class="with-gap" :checked="form.leaveDetails === 'In Hospital'" disabled>
                  <span>In Hospital (Specify Illness)</span>
                </label>
                <input v-if="form.leaveDetails === 'In Hospital'" type="text" class="browser-default mobile-input" v-model="form.sickSpecifyHospital" readonly style="margin-top: 5px;">
                
                <label>
                  <input type="radio" class="with-gap" :checked="form.leaveDetails === 'Out Patient'" disabled>
                  <span>Out Patient (Specify Illness)</span>
                </label>
                <input v-if="form.leaveDetails === 'Out Patient'" type="text" class="browser-default mobile-input" v-model="form.sickSpecifyOutPatient" readonly style="margin-top: 5px;">
              </div>

              <p class="mobile-hint" style="margin-top: 15px;">In case of Special Leave Benefits for Women:</p>
              <div class="mobile-radio-group">
                <label class="mobile-sub-label">Specify Illness:</label>
                <input type="text" class="browser-default mobile-input" v-model="form.womenSpecify" readonly>
              </div>

              <p class="mobile-hint" style="margin-top: 15px;">In case of Study Leave:</p>
              <div class="mobile-radio-group">
                <label>
                  <input type="radio" class="with-gap" :checked="form.leaveDetails === 'Completion of Master\'s Degree'" disabled>
                  <span>Completion of Master's Degree</span>
                </label>
                <label>
                  <input type="radio" class="with-gap" :checked="form.leaveDetails === 'BAR/Board Examination Review'" disabled>
                  <span>BAR/Board Examination Review</span>
                </label>
              </div>

              <p class="mobile-hint" style="margin-top: 15px;">Other purpose:</p>
              <div class="mobile-radio-group">
                <label>
                  <input type="radio" class="with-gap" :checked="form.leaveDetails === 'Monetization'" disabled>
                  <span>Monetization of Leave Credits</span>
                </label>
                <label>
                  <input type="radio" class="with-gap" :checked="form.leaveDetails === 'Terminal'" disabled>
                  <span>Terminal Leave</span>
                </label>
                <label class="mobile-sub-label" style="margin-top: 5px;">Specify other details:</label>
                <input type="text" class="browser-default mobile-input" :value="getCustomLeaveDetails(form.leaveDetails)" readonly>
              </div>
            </div>

            <div class="mobile-section read-only-mode">
              <label class="mobile-label">6.C NUMBER OF WORKING DAYS APPLIED FOR</label>
              <input type="text" class="browser-default mobile-input" v-model="form.workingDays" readonly>
              
              <label class="mobile-label" style="margin-top: 15px;">INCLUSIVE DATES</label>
              <input type="text" class="browser-default mobile-input" v-model="form.inclusiveDates" readonly style="margin-top: 10px;">
            </div>

            <div class="mobile-section read-only-mode">
              <label class="mobile-label">6.D COMMUTATION</label>
              <div class="mobile-radio-group">
                <label>
                  <input type="radio" class="with-gap" :checked="form.commutation === 'Not Requested'" disabled>
                  <span>Not Requested</span>
                </label>
                <label>
                  <input type="radio" class="with-gap" :checked="form.commutation === 'Requested'" disabled>
                  <span>Requested</span>
                </label>
              </div>
            </div>

            <div class="mobile-section-header center-align">7. DETAILS OF ACTION</div>

            <div class="mobile-section" :class="position_id === 8 ? 'editable-section' : 'read-only-mode'">
              <label class="mobile-label" :class="{ 'error-text': errors.actionAsOf || errors.section7Table }">7.A CERTIFICATION OF LEAVE CREDITS</label>
              <div style="display: flex; flex-direction: column; align-items: center; margin-bottom: 15px;">
                <span class="mobile-sub-label" style="margin-bottom: 5px;">As of:</span>
                <input ref="actionAsOf" type="date" class="browser-default mobile-input" v-model="form.actionAsOf" :readonly="position_id !== 8" style="margin: 0;">
              </div>

              <div class="mobile-table-card">
                <div class="mobile-table-row header-row">
                  <div></div>
                  <div>Vacation</div>
                  <div>Sick</div>
                </div>
                <div class="mobile-table-row">
                  <div>Earned</div>
                  <div><input type="text" class="browser-default mobile-input" style="padding: 5px; margin: 0; border: none; background: transparent;" :class="{ 'border-red': errors.section7Table && (!form.vacationEarned && form.vacationEarned !== 0) }" v-model="form.vacationEarned" @input="sanitizeDecimal('vacationEarned'); errors.section7Table = false" :readonly="position_id !== 8"></div>
                  <div><input type="text" class="browser-default mobile-input" style="padding: 5px; margin: 0; border: none; background: transparent;" :class="{ 'border-red': errors.section7Table && (!form.sickEarned && form.sickEarned !== 0) }" v-model="form.sickEarned" @input="sanitizeDecimal('sickEarned'); errors.section7Table = false" :readonly="position_id !== 8"></div>
                </div>
                <div class="mobile-table-row">
                  <div>Less Apps</div>
                  <div><input type="text" class="browser-default mobile-input" style="padding: 5px; margin: 0; border: none; background: transparent;" :class="{ 'border-red': errors.section7Table && (!form.vacationLess && form.vacationLess !== 0) }" v-model="form.vacationLess" @input="sanitizeDecimal('vacationLess'); errors.section7Table = false" :readonly="position_id !== 8"></div>
                  <div><input type="text" class="browser-default mobile-input" style="padding: 5px; margin: 0; border: none; background: transparent;" :class="{ 'border-red': errors.section7Table && (!form.sickLess && form.sickLess !== 0) }" v-model="form.sickLess" @input="sanitizeDecimal('sickLess'); errors.section7Table = false" :readonly="position_id !== 8"></div>
                </div>
                <div class="mobile-table-row footer-row">
                  <div>Balance</div>
                  <div><input type="text" class="browser-default mobile-input" style="padding: 5px; margin: 0; border: none; background: transparent;" v-model="form.vacationBalance" readonly></div>
                  <div><input type="text" class="browser-default mobile-input" style="padding: 5px; margin: 0; border: none; background: transparent;" v-model="form.sickBalance" readonly></div>
                </div>
              </div>

              <div class="center-align" style="margin-top: 30px;">
                <div v-if="signatures.hr" style="height: 50px; margin-bottom: 5px;">
                   <img :src="signatures.hr" style="max-height: 100%; object-fit: contain;">
                </div>
                <button v-if="position_id === 8" type="button" class="btn-small indigo darken-3 mobile-btn" @click="openSignatureModal('hr')">
                  <i class="material-icons left">draw</i> {{ signatures.hr ? "Retake" : "Sign Here" }}
                </button>
                <div class="mobile-signature-line" :class="{ 'error-text border-red': errors.signature && position_id === 8 }"></div>
                <span class="mobile-sub-label" :class="{ 'error-text': errors.signature && position_id === 8 }">Administrative Officer V (HRMO III)</span>
              </div>
            </div>

            <div class="mobile-section" :class="position_id === 3 ? 'editable-section' : 'read-only-mode'">
              <label class="mobile-label" :class="{ 'error-text': errors.recommendation || errors.disapprovalReason }">7.B RECOMMENDATION</label>
              <div class="mobile-radio-group">
                <label>
                  <input type="radio" class="with-gap" value="For approval" v-model="form.recommendation" :disabled="position_id !== 3">
                  <span>For approval</span>
                </label>
                <label>
                  <input type="radio" class="with-gap" value="For disapproval" v-model="form.recommendation" :disabled="position_id !== 3">
                  <span>For disapproval due to:</span>
                </label>
                <input ref="reason1" type="text" class="browser-default mobile-input" v-model="form.disapprovalReason1" :disabled="form.recommendation !== 'For disapproval' || position_id !== 3" maxlength="29" @input="handleAutoTab(form.disapprovalReason1, 29, 'reason2')" style="margin-top: 5px;">
                <input ref="reason2" type="text" class="browser-default mobile-input" v-model="form.disapprovalReason2" :disabled="form.recommendation !== 'For disapproval' || !form.disapprovalReason1 || position_id !== 3" maxlength="51" @input="handleAutoTab(form.disapprovalReason2, 51, 'reason3')" @keydown="handleBackspace($event, form.disapprovalReason2, 'reason1')" style="margin-top: 5px;">
                <input ref="reason3" type="text" class="browser-default mobile-input" v-model="form.disapprovalReason3" :disabled="form.recommendation !== 'For disapproval' || !form.disapprovalReason2 || position_id !== 3" maxlength="51" @keydown="handleBackspace($event, form.disapprovalReason3, 'reason2')" style="margin-top: 5px;">
              </div>

              <div class="center-align" style="margin-top: 30px;">
                <div v-if="signatures.supervisor" style="height: 50px; margin-bottom: 5px;">
                   <img :src="signatures.supervisor" style="max-height: 100%; object-fit: contain;">
                </div>
                <button v-if="position_id === 3" type="button" class="btn-small indigo darken-3 mobile-btn" @click="openSignatureModal('supervisor')">
                  <i class="material-icons left">draw</i> {{ signatures.supervisor ? "Retake" : "Sign Here" }}
                </button>
                <div class="mobile-signature-line" :class="{ 'error-text border-red': errors.signature && position_id === 3 }"></div>
                <span class="mobile-sub-label" :class="{ 'error-text': errors.signature && position_id === 3 }">{{ form.position === "CHIEF ADMINISTRATIVE OFFICER" ? "Assistant Regional Director" : "Immediate Supervisor"}}</span>
              </div>
            </div>

            <div class="mobile-section" :class="position_id === 1 ? 'editable-section' : 'read-only-mode'">
              <label class="mobile-label" :class="{ 'error-text': errors.approvalDays }">7.C APPROVED FOR:</label>
              
              <div style="display: flex; flex-direction: column; align-items: center; margin-bottom: 15px;">
                <span class="mobile-sub-label">Days with pay:</span>
                <input ref="approvedDaysWithPay" type="text" class="browser-default mobile-input" v-model="form.approvedDaysWithPay" @input="sanitizeDecimal('approvedDaysWithPay')" :readonly="position_id !== 1">
              </div>
              
              <div style="display: flex; flex-direction: column; align-items: center; margin-bottom: 15px;">
                <span class="mobile-sub-label">Days without pay:</span>
                <input type="text" class="browser-default mobile-input" v-model="form.approvedDaysWithoutPay" @input="sanitizeDecimal('approvedDaysWithoutPay')" :readonly="position_id !== 1">
              </div>
              
              <div style="display: flex; flex-direction: column; align-items: center; margin-bottom: 15px;">
                <span class="mobile-sub-label">Others (Specify):</span>
                <input type="text" class="browser-default mobile-input" v-model="form.approvedOthers" :readonly="position_id !== 1">
              </div>

              <label class="mobile-label" style="margin-top: 25px;">7.D DISAPPROVED DUE TO:</label>
              <input ref="finalReason1" type="text" class="browser-default mobile-input" v-model="form.finalDisapprovalReason1" :readonly="position_id !== 1" maxlength="30" @input="handleAutoTab(form.finalDisapprovalReason1, 29, 'finalReason2')" style="margin-bottom: 5px;">
              <input ref="finalReason2" type="text" class="browser-default mobile-input" v-model="form.finalDisapprovalReason2" :disabled="!form.finalDisapprovalReason1" :readonly="position_id !== 1" maxlength="57" @input="handleAutoTab(form.finalDisapprovalReason2, 57, 'finalReason3')" @keydown="handleBackspace($event, form.finalDisapprovalReason2, 'finalReason1')" style="margin-bottom: 5px;">
              <input ref="finalReason3" type="text" class="browser-default mobile-input" v-model="form.finalDisapprovalReason3" :disabled="!form.finalDisapprovalReason2" :readonly="position_id !== 1" maxlength="57" @input="handleAutoTab(form.finalDisapprovalReason3, 57, 'finalReason4')" @keydown="handleBackspace($event, form.finalDisapprovalReason3, 'finalReason2')" style="margin-bottom: 5px;">
              <input ref="finalReason4" type="text" class="browser-default mobile-input" v-model="form.finalDisapprovalReason4" :disabled="!form.finalDisapprovalReason3" :readonly="position_id !== 1" maxlength="57" @keydown="handleBackspace($event, form.finalDisapprovalReason4, 'finalReason3')">
              
              <div class="center-align" style="margin-top: 30px;">
                <div v-if="signatures.head" style="height: 50px; margin-bottom: 5px;">
                   <img :src="signatures.head" style="max-height: 100%; object-fit: contain;">
                </div>
                <button v-if="position_id === 1" type="button" class="btn-small indigo darken-3 mobile-btn" @click="openSignatureModal('head')">
                  <i class="material-icons left">draw</i> {{ signatures.head ? "Retake" : "Sign Here" }}
                </button>
                <div class="mobile-signature-line" :class="{ 'error-text border-red': errors.signature && position_id === 1 }"></div>
                <span class="mobile-sub-label" :class="{ 'error-text': errors.signature && position_id === 1 }">(Authorized Official Signature)</span>
              </div>
            </div>

            <div class="mobile-section center-align" v-if="rawApplicationData && rawApplicationData.supporting_document_path">
              <a :href="getFileUrl(rawApplicationData.supporting_document_path)" target="_blank" class="btn indigo darken-3 mobile-btn waves-effect waves-light" style="border-radius: 4px;">
                <i class="material-icons left">attach_file</i> View Attached Document
              </a>
            </div>

          </div>
        </div>

      </div>

      <div
        v-if="!loading"
        class="wizard-actions z-depth-1 white center-align"
        style="
          margin-top: 20px;
          padding: 20px;
          border-radius: 8px;
          border: 1px solid #e0e0e0;
        "
      >
        <h6 class="grey-text text-darken-2 bold" style="margin-bottom: 15px">
          Finalize Application Decision
        </h6>

        <button
          class="btn-flat grey-text text-darken-2 waves-effect"
          @click="$router.push('/leave-management')"
          style="margin-right: 15px; border: 1px solid #ccc"
        >
          Cancel
        </button>

        <button
          class="btn green darken-2 waves-light"
          @click="openActionModal('approve')"
          :disabled="isSubmitting"
        >
          <i class="material-icons left">check</i> Submit Decision
        </button>
      </div>

      <!-- UNIFIED ACTION CONFIRMATION MODAL -->
      <div
        id="actionModal"
        class="modal custom-modal-center"
      >
        <div class="modal-content">
          <h4>{{ actionModalTitle }}</h4>
          <p class="grey-text text-darken-2" style="margin-bottom: 20px">
            {{ actionModalDescription }}
          </p>

          <!-- Signature Requirement Box -->
          <div
            class="signature-requirement z-depth-1"
            style="
              margin-top: 15px;
              padding: 15px;
              border-radius: 8px;
              background-color: #f5f5f5;
            "
          >
            <div
              v-if="hasRequiredSignature"
              class="green-text text-darken-2 valign-wrapper"
              style="justify-content: center; font-weight: bold"
            >
              <i class="material-icons left">verified</i>
              Signature Provided
            </div>
            <div v-else class="center-align">
              <p class="red-text" style="margin-top: 0; font-weight: bold">
                <i class="material-icons left" style="vertical-align: bottom"
                  >warning</i
                >
                Signature is required to proceed
              </p>
              <button
                class="btn-small indigo darken-3"
                @click="triggerSignatureModal"
              >
                <i class="material-icons left">draw</i> Sign Now
              </button>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn-flat modal-close waves-effect">Cancel</button>
          <button
            class="btn waves-effect waves-light"
            :class="actionBtnClass"
            :disabled="!isActionValid || isSubmitting"
            @click="executeModalAction"
          >
            <i class="material-icons left">{{ actionIcon }}</i>
            {{ actionBtnText }}
          </button>
        </div>
      </div>

      <!-- SIGNATURE MODAL -->
      <div
        id="signatureModal"
        class="modal custom-modal-center"
        style="max-width: 700px !important;"
      >
        <div class="modal-content center-align">
          <h4>Draw Your Signature</h4>
          <p class="grey-text">
            Please sign clearly in the box below using your mouse or finger.
          </p>

          <div
            class="canvas-container z-depth-1"
            style="
              position: relative;
              width: 100%;
              max-width: 600px;
              margin: 0 auto;
              overflow: hidden;
            "
          >
            <div
              style="
                position: absolute;
                bottom: 25%;
                left: 10%;
                width: 80%;
                border-bottom: 2px solid #bdbdbd;
                pointer-events: none;
              "
            ></div>
            <div
              style="
                position: absolute;
                bottom: 10%;
                width: 100%;
                text-align: center;
                color: #9e9e9e;
                font-size: 0.85rem;
                pointer-events: none;
                font-style: italic;
              "
            >
              Sign above the line
            </div>

            <canvas
              ref="signatureCanvas"
              width="600"
              height="250"
              @mousedown.prevent="startDrawing"
              @mousemove.prevent="draw"
              @mouseup.prevent="stopDrawing"
              @mouseleave.prevent="stopDrawing"
              @touchstart.prevent="startDrawingTouch"
              @touchmove.prevent="drawTouch"
              @touchend.prevent="stopDrawing"
              style="
                position: relative;
                z-index: 5;
                background: transparent;
                width: 100%;
                height: auto;
                cursor: crosshair;
              "
            >
            </canvas>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn-flat waves-red" @click="clearSignature">
            Clear Signature
          </button>
          <button class="btn-flat" @click="$refs.leaveSigUpload.click()">
            Upload PNG
          </button>
          <button class="btn-flat" @click="useLastSignature">
            Use my last signature
          </button>
          <input ref="leaveSigUpload" type="file" accept="image/png" style="display:none" @change="onSigUpload" />
          <button
            class="btn-flat modal-close waves-green indigo-text text-darken-3 bold"
            @click="saveSignature"
          >
            Save Signature
          </button>
        </div>
      </div>
    </div>
  </FormLayout>
</template>

<script>
import FormLayout from "@/views/layout/FormLayout.vue";
import api, { apiURL } from "@/axios.js";
import { PDFDocument } from "pdf-lib";

export default {
  name: "LeaveApproverForm",
  components: { FormLayout },
  data() {
    return {
      loading: true,
      isSubmitting: false,
      rawApplicationData: null,
      position_id: null,

      // Action Modal State
      actionType: null,

      // Signature State
      signatures: {
        hr: null,
        supervisor: null,
        head: null,
      },
      activeSignatureTarget: null,
      isDrawing: false,
      ctx: null,

      errors: {
        signature: false,
        actionAsOf: false,
        recommendation: false,
        approvalDays: false,
        disapprovalReason: false,
        section7Table: false,
      },

      form: {
        office: "",
        lastName: "",
        firstName: "",
        middleName: "",
        dateOfFiling: "",
        position: "",
        salary: "",
        leaveType: "",
        leaveTypeOthers: "",
        leaveDetails: "",
        leaveDetailsSpecify: "",
        sickSpecifyHospital: "",
        sickSpecifyOutPatient: "",
        womenSpecify: "",
        othersspecify: "",
        workingDays: "",
        inclusiveDates: "",
        commutation: "",

        actionAsOf: "",
        vacationEarned: "",
        sickEarned: "",
        vacationLess: "",
        sickLess: "",
        vacationBalance: "",
        sickBalance: "",
        recommendation: "",
        disapprovalReason1: "",
        disapprovalReason2: "",
        disapprovalReason3: "",
        approvedDaysWithPay: "",
        approvedDaysWithoutPay: "",
        approvedOthers: "",
        finalDisapprovalReason1: "",
        finalDisapprovalReason2: "",
        finalDisapprovalReason3: "",
        finalDisapprovalReason4: "",
      },
    };
  },
  computed: {
    actionModalTitle() {
      return "Confirm Decision Submission";
    },
    actionModalDescription() {
      return "Are you sure you want to submit this decision?";
    },
    actionBtnClass() {
      return "green darken-2";
    },
    actionBtnText() {
      return "Confirm Submission";
    },
    actionIcon() {
      return "check";
    },
    hasRequiredSignature() {
      if (this.position_id === 8) return !!this.signatures.hr;
      if (this.position_id === 3) return !!this.signatures.supervisor;
      if (this.position_id === 1) return !!this.signatures.head;
      return (
        !!this.signatures.hr ||
        !!this.signatures.supervisor ||
        !!this.signatures.head
      );
    },
    isActionValid() {
      return this.hasRequiredSignature;
    },
  },
  methods: {
    // --- MODAL ACTION FLOW ---
    openActionModal(action) {
      // Clear previous errors
      Object.keys(this.errors).forEach((key) => (this.errors[key] = false));

      // PRE-APPROVAL VALIDATION
      if (this.position_id === 8) {
        if (!this.form.actionAsOf)
          return this.handleValidationError(
            "actionAsOf",
            "Please specify the Action As Of date.",
          );
        if (
          this.form.vacationEarned === "" ||        
          this.form.vacationEarned === null ||      
          this.form.sickEarned === "" ||            
          this.form.sickEarned === null ||          
          this.form.vacationLess === "" ||          
          this.form.vacationLess === null ||        
          this.form.sickLess === "" ||              
          this.form.sickLess === null               
          ) {
            return this.handleValidationError(
              "section7Table",
              "Please complete all required fields in Section 7.A Certification of Leave Credits.",
            );
        }
        if (!this.signatures.hr)
          return this.handleValidationError(
            "signature",
            "Please provide your signature before approving!",
          );
      }
      if (this.position_id === 3) {
        if (!this.form.recommendation)
          return this.handleValidationError(
            "recommendation",
            "Please select a recommendation.",
          );
        if (
          this.form.recommendation === "For disapproval" &&
          !this.form.disapprovalReason1
        ) {
          return this.handleValidationError(
            "disapprovalReason",
            "Please specify the reason for disapproval.",
          );
        }
        if (!this.signatures.supervisor)
          return this.handleValidationError(
            "signature",
            "Please provide your signature before approving!",
          );
      }
      if (this.position_id === 1) {
        if (this.form.recommendation === "For approval" && !this.form.finalDisapprovalReason1) {
          if (
            !this.form.approvedDaysWithPay &&
            !this.form.approvedDaysWithoutPay &&
            !this.form.approvedOthers
          ) {
            return this.handleValidationError(
              "approvalDays",
              "Please specify the approved days (with pay, without pay, or others).",
            );
          }
        }
        if (!this.signatures.head)
          return this.handleValidationError(
            "signature",
            "Please provide your signature before approving!",
          );
      }

      // If valid, open the modal
      this.actionType = action;

      const modal = document.getElementById("actionModal");
      const instance = window.M.Modal.getInstance(modal);
      instance.open();
    },

    executeModalAction() {
      if (window.M) {
        const actionModal = window.M.Modal.getInstance(
          document.getElementById("actionModal"),
        );
        if (actionModal) actionModal.close();
      }
      this.executeApiSubmission(this.actionType);
    },

    // --- SHARED API SUBMISSION ---
    async executeApiSubmission(action) {
      this.isSubmitting = true;
      if (window.M)
        window.M.toast({
          html: "Processing...",
          classes: "blue",
        });

      try {
        const generatedPdfFile = await this.generateFilledPDF();
        const formData = new FormData();

        formData.append("action", action);
        formData.append("updated_pdf", generatedPdfFile);

        const appendData = (key, value) => {
          if (value !== null && value !== undefined) {
            formData.append(key, value);
          }
        };

        appendData("action_as_of", this.form.actionAsOf);
        appendData("vacation_earned", this.form.vacationEarned);
        appendData("sick_earned", this.form.sickEarned);
        appendData("vacation_less", this.form.vacationLess);
        appendData("sick_less", this.form.sickLess);
        appendData("vacation_balance", this.form.vacationBalance);
        appendData("sick_balance", this.form.sickBalance);
        appendData("recommendation", this.form.recommendation);
        appendData("approved_days_with_pay", this.form.approvedDaysWithPay);
        appendData(
          "approved_days_without_pay",
          this.form.approvedDaysWithoutPay,
        );
        appendData("approved_others", this.form.approvedOthers);

        const combinedDisapproval = `${this.form.disapprovalReason1 || ""}${
          this.form.disapprovalReason2 || ""
        }${this.form.disapprovalReason3 || ""}`;
        appendData("disapproval_reason", combinedDisapproval);

        const combinedFinalDisapproval = `${
          this.form.finalDisapprovalReason1 || ""
        }${this.form.finalDisapprovalReason2 || ""}${
          this.form.finalDisapprovalReason3 || ""
        }${this.form.finalDisapprovalReason4 || ""}`;
        appendData("final_disapproval_reason", combinedFinalDisapproval);

        await api.post(
          `/leave-applications/${this.$route.params.id}/process`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          },
        );

        if (window.M)
          window.M.toast({
            html: `Application processed successfully!`,
            classes: "green",
          });

        setTimeout(() => {
          this.$router.push("/leave-management");
        }, 1500);
      } catch (error) {
        console.error("Error submitting decision:", error);

        if (error.response && error.response.status === 422) {
          const errors = error.response.data.errors;
          const firstError = Object.values(errors)[0][0];
          if (window.M) window.M.toast({ html: firstError, classes: "red" });
          else alert(firstError);
          return;
        }

        const errorMsg =
          error.response?.data?.error || "Failed to process application.";
        if (window.M) window.M.toast({ html: errorMsg, classes: "red" });
        else alert(errorMsg);
      } finally {
        this.isSubmitting = false;
      }
    },

    // --- SIGNATURE METHODS ---
    triggerSignatureModal() {
      // Temporarily close action modal to open signature canvas cleanly
      if (window.M) {
        const actionModal = window.M.Modal.getInstance(
          document.getElementById("actionModal"),
        );
        if (actionModal) actionModal.close();
      }

      let target = null;
      if (this.position_id === 8) target = "hr";
      else if (this.position_id === 3) target = "supervisor";
      else if (this.position_id === 1) target = "head";
      else target = "hr"; // fallback

      this.openSignatureModal(target);
    },
    openSignatureModal(target) {
      this.activeSignatureTarget = target;
      this.errors.signature = false;
      const modal = document.getElementById("signatureModal");
      const instance = window.M.Modal.getInstance(modal);
      instance.open();

      this.$nextTick(() => {
        const canvas = this.$refs.signatureCanvas;
        this.ctx = canvas.getContext("2d");
        if (!this.signatures[target]) {
          this.ctx.clearRect(0, 0, canvas.width, canvas.height);
        }
      });
    },
    startDrawing(e) {
      this.isDrawing = true;
      this.draw(e);
    },
    draw(e) {
      if (!this.isDrawing) return;
      const canvas = this.$refs.signatureCanvas;
      const rect = canvas.getBoundingClientRect();
      const scaleX = canvas.width / rect.width;
      const scaleY = canvas.height / rect.height;

      const x = (e.clientX - rect.left) * scaleX;
      const y = (e.clientY - rect.top) * scaleY;

      this.ctx.lineWidth = 3;
      this.ctx.lineCap = "round";
      this.ctx.strokeStyle = "#000";

      this.ctx.lineTo(x, y);
      this.ctx.stroke();
      this.ctx.beginPath();
      this.ctx.moveTo(x, y);
    },
    stopDrawing() {
      this.isDrawing = false;
      if (this.ctx) this.ctx.beginPath();
    },
    startDrawingTouch(e) {
      this.isDrawing = true;
      this.drawTouch(e);
    },
    drawTouch(e) {
      if (!this.isDrawing) return;
      const canvas = this.$refs.signatureCanvas;
      const rect = canvas.getBoundingClientRect();
      const scaleX = canvas.width / rect.width;
      const scaleY = canvas.height / rect.height;

      const x = (e.touches[0].clientX - rect.left) * scaleX;
      const y = (e.touches[0].clientY - rect.top) * scaleY;

      this.ctx.lineWidth = 3;
      this.ctx.lineCap = "round";
      this.ctx.strokeStyle = "#000";

      this.ctx.lineTo(x, y);
      this.ctx.stroke();
      this.ctx.beginPath();
      this.ctx.moveTo(x, y);
    },
    clearSignature() {
      if (this.ctx) {
        this.ctx.clearRect(
          0,
          0,
          this.$refs.signatureCanvas.width,
          this.$refs.signatureCanvas.height,
        );
      }
      if (this.activeSignatureTarget) {
        this.signatures[this.activeSignatureTarget] = null;
      }
    },
    saveSignature() {
      const canvas = this.$refs.signatureCanvas;
      if (this.activeSignatureTarget) {
        const dataUrl = canvas.toDataURL("image/png");
        this.signatures[this.activeSignatureTarget] = dataUrl;
        // Remember this as the user's reusable "last signature".
        api.post("/my-signature", { signature: dataUrl }).catch(() => {});
      }

      // If user came from the action modal, re-open it for them
      if (this.actionType && window.M) {
        setTimeout(() => {
          const modal = document.getElementById("actionModal");
          window.M.Modal.getInstance(modal).open();
        }, 400);
      }
    },

    // Draw an image (data URL) onto the signature canvas.
    drawImageOntoSigCanvas(dataUrl) {
      const canvas = this.$refs.signatureCanvas;
      if (!canvas) return;
      const ctx = canvas.getContext("2d");
      const img = new Image();
      img.onload = () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        const scale = Math.min(canvas.width / img.width, canvas.height / img.height);
        const w = img.width * scale, h = img.height * scale;
        ctx.drawImage(img, (canvas.width - w) / 2, (canvas.height - h) / 2, w, h);
      };
      img.src = dataUrl;
    },

    // Upload a PNG as the signature (optional alternative to drawing).
    onSigUpload(e) {
      const file = e.target.files && e.target.files[0];
      e.target.value = "";
      if (!file || file.type !== "image/png") return;
      const reader = new FileReader();
      reader.onload = (ev) => this.drawImageOntoSigCanvas(ev.target.result);
      reader.readAsDataURL(file);
    },

    // Load the user's most recent signature onto the canvas.
    async useLastSignature() {
      try {
        const res = await api.get("/my-last-signature");
        const dataUrl = res.data && res.data.signature;
        if (!dataUrl) {
          if (window.M) window.M.toast({ html: "No saved signature yet — draw or upload one.", classes: "red rounded" });
          return;
        }
        this.drawImageOntoSigCanvas(dataUrl);
      } catch (e) {
        if (window.M) window.M.toast({ html: "Could not load your last signature.", classes: "red rounded" });
      }
    },

    formatDate(dateString) {
      if (!dateString) return "";
      const options = { year: "numeric", month: "short", day: "numeric" };
      return new Date(dateString).toLocaleDateString("en-US", options);
    },

    getFileUrl(path) {
      if (path) return `${apiURL}/storage/${path}`;
      return "#";
    },

    getCustomLeaveDetails(details) {
      if (!details) return "";
      const standardOptions = [
        "Within the Philippines",
        "Abroad",
        "In Hospital",
        "Out Patient",
        "Completion of Master's Degree",
        "BAR/Board Examination Review",
        "Monetization",
        "Terminal",
      ];
      return standardOptions.includes(details) ? "" : details;
    },

    handleAutoTab(currentValue, maxLength, nextRefName) {
      if (currentValue && currentValue.length >= maxLength) {
        const nextInput = this.$refs[nextRefName];
        if (nextInput) {
          nextInput.focus();
        }
      }
    },

    handleBackspace(event, currentValue, prevRefName) {
      if (
        event.key === "Backspace" &&
        (!currentValue || currentValue.length === 0)
      ) {
        event.preventDefault();
        const prevInput = this.$refs[prevRefName];
        if (prevInput) {
          prevInput.focus();
        }
      }
    },

    handleValidationError(fieldName, message) {
      if (window.M) window.M.toast({ html: message, classes: "red" });
      else alert(message);

      Object.keys(this.errors).forEach((key) => (this.errors[key] = false));
      if (fieldName in this.errors) this.errors[fieldName] = true;

      this.$nextTick(() => {
        const errorLabel = document.querySelector(".error-text");
        if (errorLabel && errorLabel.scrollIntoView) {
          errorLabel.scrollIntoView({ behavior: "smooth", block: "center" });
        }
        
        // Find visible ref (mobile vs desktop)
        const targetElement = this.$refs[fieldName];
        if (targetElement) {
          const elements = Array.isArray(targetElement) ? targetElement : [targetElement];
          const el = elements.find(e => e.offsetParent !== null) || elements[0];
          if (el && el.focus) el.focus();
        }
      });
    },

    async fetchApplication() {
      this.loading = true;
      const id = this.$route.params.id;

      try {
        const response = await api.get(`/leave-applications/${id}`);
        const app = response.data;
        this.rawApplicationData = app;

        this.form.office = app.office;
        this.form.lastName = app.last_name;
        this.form.firstName = app.first_name;
        this.form.middleName = app.middle_name;
        this.form.dateOfFiling = app.date_of_filing;
        this.form.position = app.position;
        this.form.salary = app.salary;

        this.form.leaveType = app.leave_type;
        this.form.leaveTypeOthers = app.leave_type_others;

        this.form.leaveDetails = app.leave_details;
        this.form.leaveDetailsSpecify = app.leave_details_specify;
        this.form.sickSpecifyHospital = app.sick_specify_hospital;
        this.form.sickSpecifyOutPatient = app.sick_specify_out_patient;
        this.form.womenSpecify = app.women_specify;

        this.form.workingDays = app.working_days;
        this.form.inclusiveDates = app.inclusive_dates;
        this.form.commutation = app.commutation;

        this.form.actionAsOf = app.action_as_of
          ? app.action_as_of.split("T")[0]
          : "";
        this.form.vacationEarned = app.vacation_earned;
        this.form.sickEarned = app.sick_earned;
        this.form.vacationLess = app.vacation_less;
        this.form.sickLess = app.sick_less;
        this.form.vacationBalance = app.vacation_balance;
        this.form.sickBalance = app.sick_balance;

        this.form.recommendation = app.recommendation || "";

        if (app.disapproval_reason) {
          this.form.disapprovalReason1 = app.disapproval_reason.substring(
            0,
            29,
          );
          this.form.disapprovalReason2 = app.disapproval_reason.substring(
            29,
            80,
          );
          this.form.disapprovalReason3 = app.disapproval_reason.substring(
            80,
            131,
          );
        }

        this.form.approvedDaysWithPay = app.approved_days_with_pay;
        this.form.approvedDaysWithoutPay = app.approved_days_without_pay;
        this.form.approvedOthers = app.approved_others;

        if (app.final_disapproval_reason) {
          this.form.finalDisapprovalReason1 =
            app.final_disapproval_reason.substring(0, 80);
          this.form.finalDisapprovalReason2 =
            app.final_disapproval_reason.substring(80, 160);
          this.form.finalDisapprovalReason3 =
            app.final_disapproval_reason.substring(160, 240);
          this.form.finalDisapprovalReason4 =
            app.final_disapproval_reason.substring(240, 320);
        }
      } catch (error) {
        console.error("Error fetching application:", error);
        if (window.M)
          window.M.toast({
            html: "Failed to load application data.",
            classes: "red",
          });
        this.$router.push("/leave-management");
      } finally {
        this.loading = false;
      }
    },

    async generateFilledPDF() {
      const response = await api.get(
        `/leave-applications/${this.$route.params.id}/pdf`,
        {
          responseType: "arraybuffer",
        },
      );

      const existingPdfBytes = response.data;
      const pdfDoc = await PDFDocument.load(existingPdfBytes);
      const pdfForm = pdfDoc.getForm();
      const pages = pdfDoc.getPages();
      const firstPage = pages[0];

      const fillText = (fieldName, value) => {
        if (value === null || value === undefined || value === "") return;
        try {
          pdfForm.getTextField(fieldName).setText(value.toString());
        } catch (err) {
          /* ignore */
        }
      };

      const lockField = (fieldName) => {
        try {
          pdfForm.getTextField(fieldName).enableReadOnly();
        } catch (err) {
          /* ignore */
        }
      };

      fillText("txt-cert-Ic-asof", this.formatDate(this.form.actionAsOf));
      fillText("txt-total-earnedVLC", this.form.vacationEarned);
      fillText("txt-total-earnedSLC", this.form.sickEarned);
      fillText("txt-lessVLC", this.form.vacationLess);
      fillText("txt-lessSLC", this.form.sickLess);
      fillText("txt-balanceVLC", this.form.vacationBalance);
      fillText("txt-balanceSLC", this.form.sickBalance);

      fillText("txt-disapprove-reason1", this.form.disapprovalReason1);
      fillText("txt-disapprove-reason2", this.form.disapprovalReason2);
      fillText("txt-disapprove-reason3", this.form.disapprovalReason3);

      fillText("txt-disapproveddueto1", this.form.finalDisapprovalReason1);
      fillText("txt-disapproveddueto2", this.form.finalDisapprovalReason2);
      fillText("txt-disapproveddueto3", this.form.finalDisapprovalReason3);
      fillText("txt-disapproveddueto4", this.form.finalDisapprovalReason4);

      fillText("txt-dayswithpay", this.form.approvedDaysWithPay);
      fillText("txt-dayswopay", this.form.approvedDaysWithoutPay);
      fillText("txt-7c-others", this.form.approvedOthers);

      // --- CHECKBOX MAPS ---
      const recommendationMap = {
        "For approval": "cb25",
        "For disapproval": "cb26",
      };

      const checkNativeBox = (checkboxName) => {
        if (!checkboxName) return;
        try {
          pdfForm.getCheckBox(checkboxName).check();
        } catch (err) {
          /* ignore */
        }
      };

      checkNativeBox(recommendationMap[this.form.recommendation]);

      const drawSig = async (sigData, xPos, yPos) => {
        if (sigData) {
          try {
            const sigImageBytes = await fetch(sigData).then((res) =>
              res.arrayBuffer(),
            );
            const sigImage = await pdfDoc.embedPng(sigImageBytes);

            firstPage.drawImage(sigImage, {
              x: xPos,
              y: yPos,
              width: 130,
              height: 45,
            });
          } catch (err) {
            console.error("Could not embed signature onto PDF", err);
          }
        }
      };

      await drawSig(this.signatures.hr, 150, 165);
      await drawSig(this.signatures.supervisor, 380, 165);
      await drawSig(this.signatures.head, 270, 78);

      const approverTextFields = [
        "txt-cert-Ic-asof",
        "txt-total-earnedVLC",
        "txt-total-earnedSLC",
        "txt-lessVLC",
        "txt-lessSLC",
        "txt-balanceVLC",
        "txt-balanceSLC",
        "txt-disapprove-reason1",
        "txt-disapprove-reason2",
        "txt-disapprove-reason3",
        "txt-disapproveddueto1",
        "txt-disapproveddueto2",
        "txt-disapproveddueto3",
        "txt-disapproveddueto4",
        "txt-dayswithpay",
        "txt-dayswopay",
        "txt-7c-others",
      ];
      approverTextFields.forEach((fieldName) => lockField(fieldName));

      const today = new Date();
      let currentDate = today.toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
      });
      const formatted_date = currentDate.replace(/, /g, "_").replace(/ /g, "_");

      const pdfBytes = await pdfDoc.save();
      const pdfBlob = new Blob([pdfBytes], { type: "application/pdf" });

      return new File(
        [pdfBlob],
        `CS_Form_6_${this.form.lastName}_${this.form.firstName}_Approved_${formatted_date}.pdf`,
        { type: "application/pdf" },
      );
    },

    sanitizeDecimal(fieldName) {
      if (!this.form[fieldName]) return;
      let value = this.form[fieldName].toString();
      value = value.replace(/[^0-9.]/g, "");
      const parts = value.split(".");
      if (parts.length > 2) {
        value = parts[0] + "." + parts.slice(1).join("");
      }
      this.form[fieldName] = value;
    },
  },
  watch: {
    'form.vacationLess'(newValue) {
        if(newValue){
          this.form.vacationBalance = parseFloat(this.form.vacationEarned || 0) - parseFloat(newValue || 0);
        }else{
          this.form.vacationBalance = parseFloat(this.form.vacationEarned || 0);
        }
      },
      'form.sickLess'(newValue) {
        if(newValue){
          this.form.sickBalance = parseFloat(this.form.sickEarned || 0) - parseFloat(newValue || 0);
        }else{
          this.form.sickBalance = parseFloat(this.form.sickEarned || 0);
        }
    },
  },
  mounted() {
    const storedData = localStorage.getItem("hrdos_user");

    if (storedData) {
      const parsedUser = JSON.parse(storedData);
      this.position_id = parsedUser?.employee?.position_id || null;

      // A district head (SVTRO / TRO I / PURO, flagged by the backend) acts as
      // the District Chief on this form. Their real plantilla position_id is
      // not 3, so map them to the Chief section here — every position_id === 3
      // check below then enables the District Chief recommendation + signature
      // for them. Only applies when they aren't already an approver role.
      const approverRoles = [1, 2, 3, 8];
      if (parsedUser?.employee?.is_district_chief && !approverRoles.includes(Number(this.position_id))) {
        this.position_id = 3;
      }
    } else {
      this.position_id = null;
    }

    this.fetchApplication();

    if (window.M) {
      const modals = document.querySelectorAll(".modal");
      window.M.Modal.init(modals);
    }
  },
};
</script>

<style scoped>
.paper-form {
  color: #000;
  font-family: Arial, sans-serif;
  padding-bottom: 30px;
  width: 1010px;
  min-width: 1010px;
}
.form-inputs {
  margin-right: auto;
  margin-left: auto;
  display: block;
  width: 95%;
}
.read-only-mode {
  opacity: 0.85;
  pointer-events: none;
  background-color: #fafafa;
}
.editable-section {
  background-color: #ffffff;
}
.flex-row {
  display: flex;
  width: 100%;
}
.w-10 {
  width: 10%;
}
.w-20 {
  width: 20%;
}
.w-30 {
  width: 30%;
}
.w-35 {
  width: 35%;
}
.w-40 {
  width: 40%;
}
.w-45 {
  width: 45%;
}
.w-50 {
  width: 50%;
}
.w-55 {
  width: 55%;
}
.w-70 {
  width: 70%;
}
.border-top {
  border-top: 2px solid #000;
}
.border-right {
  border-right: 2px solid #000;
}
.padding-sm {
  padding: 8px 12px;
}
.padding-md {
  padding: 12px 16px;
}
.form-header {
  padding: 5px;
}
.header-left {
  width: 25%;
  font-size: 0.75rem;
  font-weight: bold;
}
.header-right {
  width: 25%;
  font-size: 0.75rem;
  font-weight: bold;
}
.header-center {
  width: 50%;
}
.header-logo {
  height: 90px;
  width: auto;
}
.republic-text {
  font-size: 0.85rem;
  line-height: 21px;
  font-weight: bold;
  margin: 40px 0 10px 10px;
  text-align: left;
}
.form-title {
  letter-spacing: 1px;
  font-size: 1.3rem;
  margin: 0;
}
.stamp-box {
  height: 30px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 29px 0 0 -59px;
  text-align: left;
  color: #777;
  font-weight: normal;
  font-size: 0.7rem;
}
.section-header {
  background-color: #f0f0f0;
  padding: 5px 0;
  font-size: 1rem;
}
.cs-label {
  display: block;
  font-size: 0.75rem;
  font-weight: bold;
  color: #000;
  margin-bottom: 2px;
  text-align: left;
  white-space: nowrap;
}
.form-col {
  padding: 0;
  padding-left: 2px;
}
.sub-label {
  font-size: 0.8rem;
  color: #555;
}
.cs-input {
  border-bottom: 2px solid #000 !important;
  box-shadow: none !important;
  height: 1.8rem !important;
  margin: 0 !important;
  font-size: 0.9rem !important;
  font-family: Arial, sans-serif;
  color: #000 !important;
  background-color: transparent !important;
  padding: 0 !important;
  margin-bottom: 5px !important;
  font-weight: bold !important;
  text-align: center !important;
}
.inline-line {
  border-bottom: 2px solid #000 !important;
  height: 1.2rem !important;
}
.name-grid {
  display: flex;
  gap: 10px;
}
.name-field {
  flex: 1;
  min-width: 0;
}
.name-field input {
  width: 100% !important;
}
.row1and2,
.row3,
.row6 {
  border: 2px solid black;
  margin-bottom: 3px;
}
.row4,
.row7 {
  border: 2px solid black;
}
.row5 {
  border: 2px solid black;
  border-top: none;
  margin-bottom: 3px;
}
.row8 {
  border: 2px solid black;
  border-top: none;
  border-bottom: none;
}
.row9 {
  border: 2px solid black;
  border-top: none;
}
.cert-table {
  width: 90%;
  border-collapse: collapse;
  margin-top: 3px;
  margin-bottom: 10px;
  margin-left: 35px;
  display: block;
}
.cert-table th,
.cert-table td {
  border: 1px solid #000;
  padding: 5px 8px;
  text-align: center;
  font-size: 0.85rem;
  color: #000;
}
.cert-table td:first-child {
  text-align: left;
  font-style: italic;
}
.table-input {
  border: none !important;
  box-shadow: none !important;
  margin: 0 !important;
  height: 1.2rem !important;
  text-align: center !important;
  font-size: 0.85rem !important;
  background-color: transparent !important;
  color: #000 !important;
  font-weight: bold !important;
}
.cs-custom-radios {
  display: flex;
  flex-direction: column;
  gap: 0;
}
.cs-radio-row {
  display: flex;
  align-items: stretch;
  color: #000;
  margin: 0 !important;
  margin-left: 10px !important;
}
.cs-radio-row input[type="radio"] {
  position: absolute !important;
  opacity: 0 !important;
  width: 0 !important;
  height: 0 !important;
}
.cs-box {
  width: 28px;
  border: 3px solid #000;
  border-bottom: none;
  background-color: #fff;
  margin-right: 12px;
  position: relative;
  flex-shrink: 0;
  display: inline-block;
  box-sizing: border-box;
}
.cs-radio-row:last-child .cs-box {
  border-bottom: 3px solid #000;
}
.cs-radio-row input[type="radio"]:checked + .cs-box::after {
  content: "✔";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 16px;
  color: #000;
  font-weight: bold;
  line-height: 1;
}
.cs-text {
  font-size: 1rem;
  line-height: 1.8;
}
.cs-text strong {
  font-weight: 700;
  font-size: 0.85rem;
}
.cs-text small {
  font-size: 0.6rem;
  color: #000;
  font-weight: 400;
}
.others-row {
  align-items: stretch;
}
.others-text-wrapper {
  display: flex;
  align-items: center;
  width: 100%;
}
/* Custom Centered Modal Override */
.custom-modal-center.modal {
  width: 90% !important;
  border-radius: 12px !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) scale(1) !important;
  margin: 0 !important;
  max-height: 90% !important;
  overflow-y: auto !important;
}

/* Materialize uses a scale transform for animation. We must account for the closed state. */
.custom-modal-center.modal:not(.open) {
  transform: translate(-50%, -50%) scale(0.8) !important;
}
.thick-line {
  border-bottom: 2px solid #000 !important;
}
.signature-line {
  margin: 0 auto;
  border-bottom: 2px solid #000 !important;
}
.bold {
  font-weight: bold;
}
.error-text {
  color: #d32f2f !important;
  background-color: #d32f2f8c;
}
.border-red {
  border-bottom: 2px solid #d32f2f !important;
}
.canvas-container {
  display: inline-block;
  border: 2px dashed #9e9e9e;
  border-radius: 8px;
  background-color: #fafafa;
  touch-action: none;
  position: relative;
}
.loader-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 100;
  border-radius: 2px;
}
.minimal-loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: Arial, sans-serif;
  position: sticky;
  top: 40vh;
  padding-top: 50px;
}
.loader-text {
  font-size: 1.2rem;
  font-weight: bold;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #ffffff;
  margin-bottom: 15px;
  animation: pulse 1.5s infinite;
}
.loader-line {
  width: 200px;
  height: 20px;
  background-color: rgba(255, 255, 255, 0.2);
  position: relative;
  overflow: hidden;
}
.loader-line::after {
  content: "";
  position: absolute;
  top: 0;
  left: -50px;
  width: 50px;
  height: 100%;
  background-color: #ffffff;
  animation: slide 1.5s infinite ease-in-out;
}
@keyframes pulse {
  0%,
  100% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
}
@keyframes slide {
  0% {
    left: -50px;
  }
  100% {
    left: 200px;
  }
}

/* ========================================================= */
/* MOBILE/TABLET STACKING LAYOUT (Separate Div)              */
/* ========================================================= */
.mobile-paper-form {
  padding: 15px;
  border-radius: 12px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  color: #333;
}

.mobile-section-header {
  background-color: #1565c0;
  color: white;
  padding: 10px 15px;
  font-weight: bold;
  border-radius: 6px;
  margin: 25px 0 15px 0;
  font-size: 1rem;
  letter-spacing: 0.5px;
}

.mobile-section {
  background-color: #f9f9f9;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 15px;
}

.mobile-label {
  display: block;
  font-size: 0.85rem;
  font-weight: 700;
  color: #1565c0;
  margin-bottom: 8px;
  text-align: center;
}

.mobile-sub-label {
  display: block;
  font-size: 0.75rem;
  color: #757575;
  margin-bottom: 4px;
  text-align: center;
}

.mobile-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 1rem;
  background-color: white;
  box-sizing: border-box;
  color: #333;
  text-align: center;
}
.mobile-input:focus {
  border-color: #1565c0;
  outline: none;
}
.mobile-input[disabled] {
  background-color: #eeeeee;
  color: #757575;
}

.mobile-name-grid {
  display: flex;
  gap: 10px;
  flex-direction: column;
}

.mobile-hint {
  font-size: 0.85rem;
  font-weight: 600;
  color: #424242;
  margin: 5px 0 10px 0;
  text-align: center;
}

/* Standard Materialize Radio Overrides for Mobile */
.mobile-radio-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.mobile-radio-group label {
  display: flex;
  align-items: flex-start;
}
.mobile-radio-group span {
  font-size: 0.95rem;
  color: #212121;
  padding-left: 28px !important; /* Space for the native materialize radio */
  line-height: 1.4;
}

/* Mobile Tables */
.mobile-table-card {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  background-color: white;
}
.mobile-table-row {
  display: flex;
  border-bottom: 1px solid #e0e0e0;
}
.mobile-table-row:last-child {
  border-bottom: none;
}
.mobile-table-row > div {
  flex: 1;
  padding: 10px;
  text-align: center;
  font-size: 0.9rem;
}
.mobile-table-row > div:first-child {
  font-weight: bold;
  background-color: #f5f5f5;
  text-align: left;
  border-right: 1px solid #e0e0e0;
}
.header-row > div {
  font-weight: bold;
  background-color: #f5f5f5;
  border-right: 1px solid #e0e0e0;
}
.header-row > div:last-child {
  border-right: none;
}
.footer-row {
  background-color: #e8eaf6;
  font-weight: bold;
}

/* Misc Mobile */
.mobile-btn {
  width: 100%;
  border-radius: 6px;
  margin-top: 10px;
}
.mobile-signature-line {
  border-bottom: 2px solid #000;
  width: 80%;
  margin: 0 auto 5px auto;
}
.mobile-date-picker {
  background-color: #ffffff;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 15px;
  margin-top: 10px;
}
</style>